import BaseStore from '@src/utils/store/base-store';
import NaviBarStore from '../../business-components/navibar/store';
import AntdMessage from '@src/components/antd/message';
import { reaction } from 'mobx';
import { useMount, useRequest } from 'ahooks';
import { noop } from '@src/utils/common-util';

class BaseLayoutStore extends BaseStore {
  naviBarStore = new NaviBarStore();

  executeGWConfig = noop;

  // 获取官网信息
  getGWConfig = async () => {
    return this.$ztService.gwConfig();
  };

  // 信息获取成功回调
  onGWConfigSuccess = data => {
    const { login_account = null, is_in_subscribe_code_time = -1, open_down_load = 1, down_load_get_code_status, total } = data;
    // this.$globalStore.inDownloadTime = open_down_load;
    this.$globalStore.isInSubscribeCodeTime = is_in_subscribe_code_time;
    this.$globalStore.downLoadGetCodeStatus = down_load_get_code_status;
    this.$globalStore.appointmentCount = total;

    // 礼包领取阶段
    // this.$globalStore.inAppointmentTime = 1;
    // this.$globalStore.open_down_load = 0;

    // 下载阶段
    // this.$globalStore.inAppointmentTime = 0;
    // this.$globalStore.open_down_load = 1;

    this.$globalStore.authServise.setAccountInfo(login_account);
  };

  use() {
    super.use();

    this.executeGWConfig = useRequest(async () => await this.getGWConfig(), {
      manual: true,
      onSuccess: this.onGWConfigSuccess,
      onError: e => {
        e.serviceResponse?.message && AntdMessage.error(e.serviceResponse?.message);
      }
    });

    useMount(async () => {
      // 获取官网信息
      reaction(
        () => [this.$globalStore.navbarStick],
        () => {
          this.naviBarStore.isSticky = this.$globalStore.navbarStick;
        },
        {
          fireImmediately: true
        }
      );
      await this.executeGWConfig.run();
    });
  }
}

export default BaseLayoutStore;
